import { render } from "./AI.vue?vue&type=template&id=758b32e6&scoped=true"
import script from "./AI.vue?vue&type=script&lang=js"
export * from "./AI.vue?vue&type=script&lang=js"

import "./AI.vue?vue&type=style&index=0&id=758b32e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-758b32e6"

export default script